module.exports = __webpack_public_path__ + "img/otopack250-active.199e0461.svg";